const User = () => {
  return (
    <svg
      width="12"
      height="14"
      viewBox="0 0 12 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        opacity="0.4"
        d="M4.61436 0.714175C5.4718 0.2064 6.5282 0.2064 7.38564 0.714175L10.6144 2.62623C11.4718 3.134 12 4.07241 12 5.08796V8.91206C12 9.92761 11.4718 10.866 10.6144 11.3738L7.38564 13.2858C6.5282 13.7936 5.4718 13.7936 4.61436 13.2858L1.38564 11.3738C0.528203 10.866 0 9.92761 0 8.91206V5.08796C0 4.07241 0.528203 3.134 1.38564 2.62623L4.61436 0.714175Z"
        fill="#6B50FF"
      />
      <path
        d="M4.61437 13.2857C5.47181 13.7935 6.52821 13.7935 7.38565 13.2857L10.2007 11.6187C9.3621 10.132 7.79492 9.13184 6.00001 9.13184C4.20509 9.13184 2.63792 10.132 1.79932 11.6186L4.61437 13.2857Z"
        fill="#6B50FF"
      />
      <ellipse
        cx="2"
        cy="2"
        rx="2"
        ry="2"
        transform="matrix(1 0 0 -1 4 7.66669)"
        fill="#6B50FF"
      />
    </svg>
  );
};

export default User;
